import { env } from '@/lib/env';

const FORCE_NATIVE_BILLING_LOADING_PARAM = 'jp_qa_force_native_billing_loading';
const FORCE_NATIVE_BILLING_LOADING_STORAGE_KEY = 'jp_qa_force_native_billing_loading';

function areSubscriptionQaFlagsEnabled(): boolean {
  return import.meta.env.DEV || env.enableSubscriptionQaFlags === 'true';
}

function isEnabledValue(value: string): boolean {
  return ['1', 'true', 'yes', 'on'].includes(value.trim().toLowerCase());
}

function isDisabledValue(value: string): boolean {
  return ['0', 'false', 'no', 'off'].includes(value.trim().toLowerCase());
}

function getStoredNativeBillingLoadingForce(): string | null {
  try {
    return window.localStorage.getItem(FORCE_NATIVE_BILLING_LOADING_STORAGE_KEY);
  } catch {
    return null;
  }
}

function setStoredNativeBillingLoadingForce(): void {
  try {
    window.localStorage.setItem(FORCE_NATIVE_BILLING_LOADING_STORAGE_KEY, '1');
  } catch {
    // Ignore storage failures; the current URL parameter still controls this page load.
  }
}

function clearStoredNativeBillingLoadingForce(): void {
  try {
    window.localStorage.removeItem(FORCE_NATIVE_BILLING_LOADING_STORAGE_KEY);
  } catch {
    // Ignore storage failures in restricted browser storage environments.
  }
}

export function isNativeBillingLoadingQaForced(): boolean {
  if (typeof window === 'undefined') return false;

  if (!areSubscriptionQaFlagsEnabled()) {
    clearStoredNativeBillingLoadingForce();
    return false;
  }

  const url = new URL(window.location.href);
  const paramValue = url.searchParams.get(FORCE_NATIVE_BILLING_LOADING_PARAM);

  if (paramValue !== null) {
    if (isEnabledValue(paramValue)) {
      setStoredNativeBillingLoadingForce();
      return true;
    }

    if (isDisabledValue(paramValue)) {
      clearStoredNativeBillingLoadingForce();
      return false;
    }
  }

  return getStoredNativeBillingLoadingForce() === '1';
}

export function clearNativeBillingLoadingQaForce(): void {
  if (typeof window === 'undefined') return;

  clearStoredNativeBillingLoadingForce();
}
